"use client";

import type { FC } from "react";

import { isPreviewing } from "@builder.io/sdk-react";

import { StoreLocator as UIStoreLocator } from "@des/locators/components/StoreLocator";

import type { storeLocatorInputs } from "./StoreLocator.builder";

type StoreLocatorBuilderProps = BuilderComponentProps<typeof storeLocatorInputs>;

const DEFAULT_ZOOM = 15;

export const StoreLocator: FC<StoreLocatorBuilderProps> = ({
  defaultLatitude,
  defaultLongitude,
  storesLimit,
  defaultZoom,
  componentLevelLanguage,
  storeLocatorDetailsPageUrl,
  filtersTranslations,
  filtersEnabled = true,
  isSearchVisible = true,
  isOpeningHoursEnabled,
  isOpeningHoursBreaksEnabled,
  isAvailableDevicesEnabled,
  isAvailableSticksEnabled,
  isMultiBrandSticksEnabled,
  storeDetailsPageTarget,
  isMapInteractionEnabled,
  defaultStoreIcon,
  enabledFiltersCategories,
  defaultOpenedFilterCategory,
  isMultipleFiltersSectionOpenEnabled,
  isFiltersSharingEnabled = false,
  isMapPositionFromUrlEnabled = false,
  isInputExtraTextVisible = false,
  isGeneralAnnouncementEnabled = false,
  isAvailableServicesEnabled = false,
  isStoreTypeEnabled = false,
  isVendingMachineEnabled = false,
  isVendingMachineTipEnabled = false,
  isNearbyShopsEnabled,
  isAsianAddressFormatEnabled,
}) => {
  const target = storeDetailsPageTarget === "sameTab" ? "_self" : "_blank";

  return (
    <UIStoreLocator
      defaultLat={String(defaultLatitude)}
      defaultLng={String(defaultLongitude)}
      defaultZoom={defaultZoom || DEFAULT_ZOOM}
      storeDetailsPage={storeLocatorDetailsPageUrl || ""}
      storeDetailsPageTarget={target}
      defaultStoreIcon={defaultStoreIcon}
      storesLimit={storesLimit || 0}
      filtersEnabled={filtersEnabled}
      isSearchVisible={isSearchVisible}
      filtersTranslations={filtersTranslations || []}
      isFiltersSharingEnabled={!isPreviewing() && isFiltersSharingEnabled}
      isMapPositionFromUrlEnabled={isMapPositionFromUrlEnabled}
      isOpeningHoursEnabled={isOpeningHoursEnabled}
      isOpeningHoursBreaksEnabled={isOpeningHoursBreaksEnabled}
      isAvailableDevicesEnabled={isAvailableDevicesEnabled}
      isAvailableSticksEnabled={isAvailableSticksEnabled}
      isGeneralAnnouncementEnabled={isGeneralAnnouncementEnabled}
      isMultiBrandSticksEnabled={isMultiBrandSticksEnabled}
      isAvailableServicesEnabled={isAvailableServicesEnabled}
      isStoreTypeEnabled={isStoreTypeEnabled}
      isVendingMachineEnabled={isVendingMachineEnabled}
      isMapInteractionEnabled={isMapInteractionEnabled}
      isVendingMachineTipEnabled={isVendingMachineTipEnabled}
      isMultipleFiltersSectionOpenEnabled={isMultipleFiltersSectionOpenEnabled}
      defaultOpenedFilterCategory={defaultOpenedFilterCategory}
      enabledFiltersCategories={
        enabledFiltersCategories || {
          isProductTypesFilterEnabled: true,
          isStoreServicesFilterEnabled: true,
        }
      }
      componentLevelLanguage={componentLevelLanguage}
      isInputExtraTextVisible={isInputExtraTextVisible}
      isNearbyShopsEnabled={isNearbyShopsEnabled}
      isAsianAddressFormatEnabled={isAsianAddressFormatEnabled}
    ></UIStoreLocator>
  );
};
